import * as XLSX from "xlsx";

const rows = (groups, byGroup) => {
  const out = [];
  groups.forEach((g) => {
    const list = byGroup[g.id] || [];
    list.forEach((e) => out.push({
      "Group Name": g.name, Date: e.entry_date, "Site Name": e.site_name, "User ID": e.user_code, "Settlement Amount (INR)": e.amount,
    }));
    if (list.length) out.push({ "Group Name": `${g.name} TOTAL`, "Settlement Amount (INR)": list.reduce((s, e) => s + e.amount, 0) });
  });
  return out;
};

export const exportData = (groups, byGroup, type) => {
  const ws = XLSX.utils.json_to_sheet(rows(groups, byGroup));
  const stamp = new Date().toLocaleDateString("en-CA");
  if (type === "csv") {
    const blob = new Blob([XLSX.utils.sheet_to_csv(ws)], { type: "text/csv;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `settlements-${stamp}.csv`;
    a.click();
    return;
  }
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Settlements");
  XLSX.writeFile(wb, `settlements-${stamp}.xlsx`);
};
